const UNSUBSCRIPTION_STEPS = {
    REMOVAL: 'REMOVAL',
    CONFIRMATION: 'CONFIRMATION',
    UNSUBSCRIBE_SUCCESS: 'UNSUBSCRIBE_SUCCESS',
    NO_UNSUBSCRIBE: 'NO_UNSUBSCRIBE',
};

export default UNSUBSCRIPTION_STEPS;